export default function Introduction() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1e3a8a] mb-6">목형(목금형)이란?</h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-8"></div>
          <p className="text-lg text-gray-700 leading-relaxed max-w-4xl mx-auto">
            목형은 주물 제작을 위한 나무로 만든 원형 틀로, 금속 주조 공정에서 필수적인 역할을 합니다.<br />
            재기목형은 포장재 및 제품 생산용 특수목형 제작을 전문으로 하며,<br />
            30년 이상의 경험과 숙련된 기술진이 최고 품질의 목형을 제작합니다.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="bg-gradient-to-br from-[#1e3a8a] to-[#2563eb] p-8 rounded-xl text-white shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
              <i className="ri-tools-fill text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4">특수목형 전문</h3>
            <p className="text-white/90 leading-relaxed">
              포장재 및 제품 생산용 특수목형 제작에 특화되어 있으며, 다양한 산업 분야의 요구사항을 충족시킵니다.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#1e3a8a] to-[#2563eb] p-8 rounded-xl text-white shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
              <i className="ri-team-fill text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4">숙련된 기술진</h3>
            <p className="text-white/90 leading-relaxed">
              장기근속 직원들의 전문성과 노하우로 정밀하고 완성도 높은 목형을 제작합니다.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#1e3a8a] to-[#2563eb] p-8 rounded-xl text-white shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
              <i className="ri-map-pin-fill text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4">전국 네트워크</h3>
            <p className="text-white/90 leading-relaxed">
              전국에 거래처를 두고 있으며, 업계 최고 수준의 제품을 생산하여 공급하고 있습니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
